import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	browseAllAgentsButtonLabel: {
		id: 'autodev.agent-picker.browse-all-template-modal-entry-label',
		defaultMessage: 'Browse all Agents',
		description:
			'Browse all agents button to open a modal where users can browse existing templates.',
	},
	runAiCodingToolButtonLabel: {
		id: 'autodev.agent-picker.run-ai-coding-tool-button-label',
		defaultMessage: 'Use AI coding tool',
		description:
			'The label of the button that runs the Coding with AI process with the selected Rovo Agent.',
	},
});
